import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button, Link, Modal } from "@mui/material";
import BulkUploadForm from "../../Common/BulkUploadFormSP/BulkUploadForm";
import "../LocationDetail/LocationDetail.scss";
import LocationPopup from "../../../Pages/Desktop/Broker/Clients/ClientDetails/ClientDetailsPopup/LocationPopup";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const LocationDetail: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [locationPopup, setLocationPopup] = React.useState(false);

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  const [locationData, setLocationData] = React.useState([
    {
      companyName: "",
      locationType: "",
      companyAddress: "",
      spoc: "",
      activePolicies: "",
      actionBtn: "",
    },
  ]);

  useEffect(() => {
    setLocationData([
      {
        companyName: "Evervent",
        locationType: "Registered Office",
        companyAddress:
          "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
        spoc: "SP01 - Satish (9876543210)",
        activePolicies: "5",
        actionBtn: "images/edit_icon.svg",
      },
      {
        companyName: "Evervent",
        locationType: "Head Office",
        companyAddress:
          "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
        spoc: "SP01 - Satish (9876543210)",
        activePolicies: "5",
        actionBtn: "images/edit_icon.svg",
      },
      {
        companyName: "Evervent",
        locationType: "RnD Office",
        companyAddress:
          "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
        spoc: "SP01 - Satish (9876543210)",
        activePolicies: "5",
        actionBtn: "images/edit_icon.svg",
      },
      {
        companyName: "Evervent",
        locationType: "Front Office",
        companyAddress:
          "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
        spoc: "SP01 - Satish (9876543210)",
        activePolicies: "5",
        actionBtn: "images/edit_icon.svg",
      },
      {
        companyName: "Evervent",
        locationType: "Head Office",
        companyAddress:
          "321, Industrial Area  , Phase 9, Mohali, Punjab, India - 1411111",
        spoc: "SP01 - Satish (9876543210)",
        activePolicies: "5",
        actionBtn: "images/edit_icon.svg",
      },
    ]);
  }, []);

  return (
    <Box>
      <LocationPopup
        open_status={locationPopup}
        attrName={setLocationPopup}
        value_update={updateMasterState}
      />

      <Grid container spacing={3}>
        <Grid xs={12}>
          <div className="table">
            <div className="location-table">
              <ul className="heading">
                <li>Name</li>
                <li>Type</li>
                <li>Address</li>
                <li>SPOC</li>
                <li>Active Policies</li>
                <li>Actions</li>
              </ul>

              {locationData.map((data, index) => (
                <ul className="subheading">
                  <li>{data.companyName}</li>
                  <li>{data.locationType}</li>
                  <li>{data.companyAddress}</li>
                  <li>{data.spoc}</li>
                  <li>{data.activePolicies}</li>
                  <li>
                    <Link className="edit_address_link">
                      <img src={data.actionBtn} alt="" />
                    </Link>
                  </li>
                </ul>
              ))}
            </div>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default LocationDetail;
